import vue from '@/main';
import {AREAS, INDUSTRIES, LOCATIONS} from '@/utils/constants/jobs';

const availableFilters = [
  {
    type: LOCATIONS,
    label: vue.$gettext('Location'),
    icon: 'location',
    separateTopOptions: true
  },
  {
    type: INDUSTRIES,
    label: vue.$gettext('Industry'),
    icon: 'industry',
    separateTopOptions: false
  },
  {
    type: AREAS,
    dependency: INDUSTRIES,
    label: vue.$gettext('Area of expertise'),
    dependencyPlaceholder: vue.$gettext('Select an Industry first'),
    icon: 'position',
    separateTopOptions: false
  }
];

export default {availableFilters};
